import "./index.scss";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { CircularProgress, FormControl, Select, SelectProps } from "@mui/material";
import React, { FC } from "react";

export interface DropdownProps extends SelectProps {
  loading?: boolean;
  selectedOptions?: any;
  customRenderItem?: (item: any, index: number) => React.ReactNode;
  showLabel?: boolean;
  shrink?: boolean;
  fullWidth?: boolean;
}

const MemberListDropdownComponent: FC<DropdownProps> = (props) => {
  const {
    loading = false,
    label = "",
    multiple,
    selectedOptions,
    customRenderItem,
    showLabel = true,
    shrink = true,
    fullWidth,
    children,
    ...restProps
  } = props;

  return (
    <FormControl fullWidth={fullWidth} className="member-list-dropdown-container">
      <Select
        IconComponent={(props) =>
          loading ? (
            <CircularProgress disableShrink color="success" size={20} {...props} />
          ) : (
            <KeyboardArrowDownIcon sx={{ marginRight: 1 }} />
          )
        }
        {...restProps}
      >
        {children}
      </Select>
    </FormControl>
  );
};

const MemberListDropdown = MemberListDropdownComponent;
export default MemberListDropdown;
